import { Swiper, Navigation, Pagination } from '../../../node_modules/swiper/dist/js/swiper.esm.js';

Swiper.use([Navigation, Pagination]);

(function () {
  const swipers = [...document.querySelectorAll('[data-swiper]')];

  swipers.forEach(e => {

    let swiperOptions = e.dataset.swiperOptions
      ? JSON.parse(e.dataset.swiperOptions)
      : {};

    new Swiper(e, {
      observer: true,
      observeParents: true,
      autoHeight: true,
      watchOverflow: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      ...swiperOptions,
    });
  });

  const sliders = [...document.querySelectorAll('[data-slides]')];

  sliders.forEach(e => {
    new Swiper(e, {
      observer: true,
      observeParents: true,
      watchOverflow: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
    });
  });


})();
